<template>
    <div>
        <MenuHeader :logo="logo"></MenuHeader>
        <MenuLeft></MenuLeft>
        <div class="layout-main" id="main">
        <router-view />
        </div>
        
    </div>
</template>
<script>
import MenuHeader from "../components/MenuHeader.vue";
import MenuLeft from "../components/MenuLeft.vue";
export default {
    name: "Main",
    components: {
        MenuHeader,
        MenuLeft,
    },
    props: [
        "logo",
    ],
    data() {
        return {
           
        }
    },
    
    methods: {

    },
    
    }
</script>
<style>
.alinearizquierda{
    text-align: right;
}
.colorback{
    color: var(--blue-violet);
    font-weight: 800;
    cursor: pointer;
}
.layout-main{
    padding: 6% 0% 0% 5%;
    height: 800px;
    overflow: auto;
    position: relative;
    /* background-color: var(--zircon); */
 
}
.table > thead {
    vertical-align: bottom;
    background: var(--hover2);
    color: white;
    font-weight: 800;
    text-align: center;
    font-size: 18px;
    border-top-right-radius: 45px;
    border-top-left-radius: 45px;
}
.table > tbody {
    vertical-align: inherit;
    text-align: center;
}
.pagination {

}
.vue-form-generator .form-control:not([class*=" col-"]){
    appearance: auto;
}
.bton{
  z-index: 1;
}
@media (max-height: 749px) {
    .layout-main{
   /* padding: 10% 0% 0% 9% !important;*/
    height: 650px;
    overflow: auto;
    position: relative;
    /* background-color: var(--zircon); */
 
}
}
@media(max-height: 800px)and (max-height: 900px) {
    .layout-main{
   /* padding: 6% 0% 0% 5%;*/
    height: 800x;
    overflow: auto;
    position: relative;
    /* background-color: var(--zircon); */
 
}
}

</style>